import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconContainer } from './Styled';
import type { SystemIconProps } from './SystemIcon';

export default function IconTooltip({ isSystem, children }: SystemIconProps) {
  const { t } = useTranslation('translation');

  return (
    <IconContainer>
      <Tooltip
        title={isSystem ? t(($) => $.ideaManagement.general.systemFieldToolTip) : ''}
        disableHoverListener={!isSystem}
        arrow
      >
        <div
          style={{
            height: '26px',
            width: '26px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </div>
      </Tooltip>
    </IconContainer>
  );
}
